import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { setTypography } from 'utils/styles/mixins';
import { mediaDesktop } from 'utils/styles/responsive';
import { colors } from 'utils/styles/theme';

export const JoinUsOpportunityViewWrapper = styled(motion.div)`
  margin: 132px 16px 120px 16px;
  color: ${colors.black};

  ${mediaDesktop(css`
    margin: 144px 122px 160px 122px;
  `)}
`;

export const Label = styled.div`
  ${({ theme: { locale } }) => setTypography('small', locale)}
`;

export const HeaderWrapper = styled(motion.div)``;

export const Header = styled.div`
  ${Label} {
    ${({ theme: { locale } }) => setTypography('smallBody', locale)}
    margin-bottom: 12px;

    ${mediaDesktop(css`
      margin-bottom: 8px;
    `)}
  }
`;

export const Title = styled.div`
  ${({ theme: { locale } }) => setTypography('heading2', locale)}
  margin-bottom: 56px;

  ${mediaDesktop(css`
    margin-bottom: 80px;
  `)}
`;

export const DataWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 20px;

  padding-bottom: 20px;
  border-bottom: 1px solid ${colors.mercury};

  ${mediaDesktop(css`
    grid-column-gap: 32px;
    grid-row-gap: 48px;
    padding-bottom: 48px;
  `)}
`;

export const Data = styled.div`
  border-top: 1px solid ${colors.mercury};
  padding: 12px 0;

  ${Label} {
    margin-bottom: 5px;
  }

  ${mediaDesktop(css`
    padding-bottom: 0;
  `)}
`;

export const Value = styled.div`
  ${({ theme: { locale } }) => setTypography('heading5', locale)}
`;

export const Socials = styled.div`
  ${Label} {
    margin: 12px 0;
  }

  margin-bottom: 72px;

  ${mediaDesktop(css`
    margin-bottom: 105px;
  `)}
`;

export const ShareScroll = styled.div`
  display: flex;
  white-space: nowrap;

  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Badge = styled.div`
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.concrete};
  padding: 10px 16px;
  border-radius: 33px;
  text-align: center;
  white-space: nowrap;
  cursor: pointer;

  ${({ theme: { locale } }) => setTypography('filter', locale)}
`;

export const Content = styled.div`
  margin-bottom: 56px;

  ${mediaDesktop(css`
    margin-bottom: 80px;
  `)}

  h1,
  h2,
  h3,
  h4,
  h5 {
    ${({ theme: { locale } }) => setTypography('heading5', locale)}
    margin-bottom: 20px;

    ${mediaDesktop(css`
      margin-bottom: 24px;
    `)}
  }

  p {
    ${({ theme: { locale } }) => setTypography('body', locale)}
    margin-bottom: 64px;

    ${mediaDesktop(css`
      margin-bottom: 80px;
    `)}
  }

  a {
    text-decoration: underline;
  }

  ul {
    list-style-type: disc;
    -webkit-margin-before: 1em;
    -webkit-margin-after: 1em;
    -webkit-margin-start: 0px;
    -webkit-margin-end: 0px;
    -webkit-padding-start: 25px;
  }
`;
